<template>
  <Adminlte>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">Validação de Questionários</h3>
      </div>
      <div class="box-body">
        <table id="park-quiz-validation-table" class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>Parque Tecnológico</th>
            <th>Ano</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in waittingApprovalParkQuizzes" v-if="waittingApprovalParkQuizzes.length > 0">
            <td>{{ row.parkName }}</td>
            <td>{{ row.parkQuizYear }}</td>
            <td>
              <button class="btn btn-xs btn-primary"
                @click="validateParkQuiz(row.parkId, row.parkName, row.parkQuizUuid, row.parkQuizYear)">
                <i class="fa fa-pencil"></i>&nbsp Validar
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import ParkQuizClient from '@/services/resource_client/park_quiz'

  export default {
    name: 'ParkQuizValidationList',
    components: { Adminlte },
    data () {
      return {
        waittingApprovalParkQuizzes: []
      }
    },
    created () {
      ParkQuizClient.waittingApproval()
        .then((r) => { this.waittingApprovalParkQuizzes = r.data })
        .then(() => $('#park-quiz-validation-table').DataTable())
    },
    methods: {
      validateParkQuiz (parkId, parkName, parkQuizUuid, parkQuizYear) {
        this.$router.push({
          name: 'ParkQuizValidation',
          params: {
            parkId,
            'parkName': parkName,
            'quizUuid': parkQuizUuid,
            'referenceYear': parkQuizYear
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ParkQuizValidationList.vue?5ccd6c37